export function filtrarCitasCalendario(citas, usuario, usuarioSeleccionadoId) {
  if (!Array.isArray(citas)) return [];

  const usuarioId = usuario?._id ? String(usuario._id) : '';
  const seleccion = String(usuarioSeleccionadoId || '').trim();

  if (!usuario) return [];

  if (usuario.rol === 'superadmin' || usuario.rol === 'admin') {
    if (!seleccion || seleccion === 'todos') return citas;
    return citas.filter((cita) => String(cita?.asignadoA?._id || cita?.asignadoA || '').trim() === seleccion);
  }

  return citas.filter((cita) => String(cita?.asignadoA?._id || cita?.asignadoA || '').trim() === usuarioId);
}

export function filtrarTareasCalendario(tareas, usuario) {
  const usuarioId = String(usuario?._id || '').trim();
  if (!usuarioId || !Array.isArray(tareas)) return [];
  return tareas.filter((tarea) => {
    const asignadoId = String(tarea?.asignadoA?._id || tarea?.asignadoA || '').trim();
    return asignadoId === usuarioId && Boolean(tarea.fechaTope) && Number.isFinite(new Date(tarea.fechaTope).getTime());
  });
}

export function eventosCalendarioPorDia(citas, tareas) {
  const mapa = new Map();
  const eventos = [
    ...citas.map((dato) => ({ tipo: 'cita', dato, fecha: new Date(dato.inicio) })),
    ...tareas.map((dato) => ({ tipo: 'tarea', dato, fecha: new Date(dato.fechaTope) })),
  ].filter((evento) => Number.isFinite(evento.fecha.getTime()))
    .sort((primero, segundo) => primero.fecha - segundo.fecha);
  eventos.forEach((evento) => {
    const { fecha } = evento;
    const clave = `${fecha.getFullYear()}-${fecha.getMonth()}-${fecha.getDate()}`;
    const lista = mapa.get(clave) || [];
    lista.push(evento);
    mapa.set(clave, lista);
  });
  return mapa;
}
